import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as Data from '../Data';
import * as DatiFide from '../DatiFide';
import { NavLink } from 'react-router-dom';
import { BaseComponent, ChiamaAPI, BottoneAPI, Trad, Tipo, Contesto, CampoNumero, CampoData, GraficoTorta, Deroga, FideAffidamentoApprovazione, GraficoLimite, CambioStatoBottoni } from '../components/';

interface IFideAffidamentoState {
    Dato: DatiFide.CRisAPIDatoTipi_FideAffidamento;
    LimitiSOA: Dati.CRisAPIDizionario<number>;
    ListaCampiDeroga: Dati.TListaParametriDeroga;
}

export class FideAffidamento extends BaseComponent<Glob.IRouteGlobaleProps, IFideAffidamentoState> {

    private ID_FideAffidamento: number = 0;
    private _DataRiferimento: string;
    private _Incremento: number = 0;

    private _LimitiDeroga: Dati.Dictionary<any> = {};
    private _Limiti: Dati.Dictionary<number> = {};

    private _ID_TipoFideAffidamentoEsito: string = "";

    constructor(props: any) {

        super(props);
        var datiAff: DatiFide.CRisAPIDatoTipi_FideAffidamento = new DatiFide.CRisAPIDatoTipi_FideAffidamento();
        datiAff.Dato.ID_TipoFideAffidamento = Glob.Tipi_FA_Affidamento;
        datiAff.Dato.ID_AnagA = (this.props.match.params as any).ID_Anag;
        datiAff.Dato.ID_AnagDa = Glob.GetSessione().ID_Anag;

        //this._Regole = "[{'Dato.LimiteMassimoContraente':{'<': 'Dato.LimiteMassimoFideiussione', 'required':true}}]";
        //this._Regole = '[{"Campo":"LimiteMassimoContraente", "Regole":[{"Azione": ">", "Soggetto":"LimiteMassimoFideiussione", "Valore": 0}, {"Azione":"required"}]}]';//"[{'Dato.LimiteMassimoContraente':'ciao'}]";

        this.state = {
            Dato: datiAff, LimitiSOA: new Dati.CRisAPIDizionario<number>(), ListaCampiDeroga: {}
        };

        this.ID_FideAffidamento = (this.props.match.params as any).ID_FideAffidamento;
        this._DataRiferimento = (this.props.match.params as any).DataRiferimento != undefined ? (this.props.match.params as any).DataRiferimento : Data.DataValoreCompleta(new Date());
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnClickSalva = this.OnClickSalva.bind(this);

        if (this.ID_FideAffidamento > 0) {
            this.SetMenu(24, { ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString() });
        } else {
            this.SetMenu(0, {});
        }

        this.RegolaValidazione = this.RegolaValidazione.bind(this);
        this.RegoleCheck = this.RegoleCheck.bind(this);
        this.OnRisRegola = this.OnRisRegola.bind(this);
        this.OnChangeDataSottoscrizione = this.OnChangeDataSottoscrizione.bind(this);
        this.OnChangeTipoAffidamento = this.OnChangeTipoAffidamento.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnErroreBottoneAPI = this.OnErroreBottoneAPI.bind(this);
        this.OnInvioSalva = this.OnInvioSalva.bind(this);
        this.OnInvioSalvaCambioStato = this.OnInvioSalvaCambioStato.bind(this);
        this.OnCaricaLimitiAffidamento = this.OnCaricaLimitiAffidamento.bind(this);
    }

    private SetMenu(menu: number, variabili: { [D: string]: string }) {
        var M = Glob.GetMenu();
        M.Main = "Affidamento";
        M.ID_MenuMain = menu;
        M.VariabiliMenu = variabili;
        this.props.SetMenu(M);
    }

    private OnRis(sender: ChiamaAPI, dati: DatiFide.CRisAPIDatoTipi_FideAffidamento, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_FideAffidamento > 0) {
                this.setState({ Dato: dati });

                this._ID_TipoFideAffidamentoEsito = dati.Dato.ID_TipoFideAffidamentoEsito;

                let menu = 0;
                if (dati.Dato.ID_FideAffidamento > 0) {
                    menu = 24;
                }
                var M = Glob.GetMenu();
                M.Main = "Affidamento";
                M.ID_MenuMain = menu;
                M.VariabiliMenu = { ["{ID_FideAffidamento}"]: dati.Dato.ID_FideAffidamento.toString() };
                this.props.SetMenu(M);
            }
            else {
                this.state.Dato.Tipi = dati.Tipi;
                this.setState({ Dato: this.state.Dato });
            }
        }

        return false;
    }

    private OnRisLimitiSOA(sender: ChiamaAPI, dati: Dati.CRisAPIDizionario<number>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                this.setState({ LimitiSOA: dati });
            }
        }
        return false;
    }

    private OnCaricaLimitiCapogruppo(sender: ChiamaAPI, dati: DatiFide.CRisAPIListaLimitiFideAffidamentoCapogruppo): React.ReactNode {
        if (dati.Dati != undefined) {
            let datiGrafico: number[] = [];
            let etichette: string[] = [];
            let coloriDiSfondo: string[] = [];
            let coloriDiSfondoSuSelezione: string[] = [];
            let LimiteRimasto: number = 0;
            for (let i: number = 0; i < dati.Dati.length; i++) {
                LimiteRimasto += dati.Dati[i].LimiteMassimoContraente - dati.Dati[i].LimiteMassimoContraenteUtilizzato
                datiGrafico.push(dati.Dati[i].LimiteMassimoContraenteUtilizzato);
                etichette.push(Trad.TradParam("{1-S}: Affidamento utilizzato {2-I}", [dati.Dati[i].ID_FideAffidamento + " " + dati.Dati[i].Denominazione, dati.Dati[i].LimiteMassimoContraenteUtilizzato]));
                let colore: string = Glob.ColoreStatic(i);
                coloriDiSfondo.push(colore);
                coloriDiSfondoSuSelezione.push("#EAF4F9");
            }
            datiGrafico.push(LimiteRimasto);
            etichette.push(Trad.TradParam("Affidamenti non utilizzati {1-I}", [LimiteRimasto]));
            let colore: string = Glob.ColoreRandom();
            coloriDiSfondo.push(colore);
            coloriDiSfondoSuSelezione.push("#EAF4F9");
            if (dati.Dati.length > 0)
                return <GraficoTorta Altezza={100} Larghezza={100} Titolo={Trad.Trad("Affidamenti gruppo")} Dati={datiGrafico} Etichette={etichette} ColoriDiSfondo={coloriDiSfondo} ColoriDiSfondoSuSelezione={coloriDiSfondoSuSelezione} />;
            else
                return <div></div>;
        }
        else
            return false;
    }

    private OnClickSalva(sender: BottoneAPI, dati: DatiFide.CRisAPIDatoTipi_FideAffidamento) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            this.ID_FideAffidamento = dati.ID_Chiave;
            var tmp: DatiFide.CRisAPIDatoTipi_FideAffidamento = this.state.Dato;
            tmp.Dato.ID_FideAffidamento = this.ID_FideAffidamento;
            tmp.Dato.ListaFideAffidamentoApprovazioneJSON = dati.MessaggioDati;
            this.setState({ Dato: tmp });
            this.props.history.replace("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + dati.ID_Chiave);
            Glob.InfoModaleSuccess(Trad.Trad("AFFIDAMENTO"), Trad.TradParam("Affidamento salvato correttamente con ID: {1-S}", [this.ID_FideAffidamento]));
            this._ID_TipoFideAffidamentoEsito = tmp.Dato.ID_TipoFideAffidamentoEsito;
        }

        if (this.ID_FideAffidamento > 0) {
            this.SetMenu(24, { ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString() });
        } else {
            this.SetMenu(0, {});
        }
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        return this.OnInvioSalvaCambioStato(this.state.Dato.Dato.ID_TipoFideAffidamentoEsito);
    }

    private OnInvioSalvaCambioStato(nuovoStato: string): any {
        let ListaCampiEsclusi: string[] = [];

        switch (this.state.Dato.Dato.ID_TipoFideAffidamento) {
            case Glob.Tipi_FA_Affidamento:
                ListaCampiEsclusi.push("LimiteMassimoContraente");
                ListaCampiEsclusi.push("LimiteMassimoFideiussione");
                break;
            case Glob.Tipi_FA_NonProvvisorie:
            case Glob.Tipi_FA_Provvisorie:
                ListaCampiEsclusi.push("LimiteMassimoContraente_Provvisorie");
                ListaCampiEsclusi.push("LimiteMassimoFideiussione_Provvisorie");
                ListaCampiEsclusi.push("LimiteMassimoContraente_NonProvvisorie");
                ListaCampiEsclusi.push("LimiteMassimoFideiussione_NonProvvisorie");
                break;
        }

        if (!this.RegoleCheck(this.state.Dato.Dato, ListaCampiEsclusi)) {
            var Ingr = new Dati.CIngrAPI<DatiFide.CDatiFideAffidamento>();
            Ingr.Dato = this.state.Dato.Dato;
            Ingr.Dato.ID_TipoFideAffidamentoEsito = nuovoStato;
            return Ingr;
        } else { return false; }
    }

    private OnInvioRevisione(sender: BottoneAPI): any {
        var Ingr = this.OnInvioSalva(sender);
        if (typeof (Ingr) != "boolean") {
            Ingr.Dato.ID_TipoFideAffidamentoEsito = Glob.Tipi_FAE_Revisione;
            Ingr.Dato.ListaFideAffidamentoApprovazioneJSON = "[]";
            return Ingr;
        } else {
            return false;
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    private OnChangeTipoAffidamento(e: React.FormEvent<any> | string, valore?: any): any {
        this.OnChange(e, valore);
        switch (this.state.Dato.Dato.ID_TipoFideAffidamento) {
            case Glob.Tipi_FA_NonProvvisorie:
                this.state.Dato.Dato.ID_TipoSOA = "";
                this.setState({ Dato: this.state.Dato });
                break;
        }
    }

    private OnChangeDeroga(e: React.FormEvent<any>, tipo: string, verso: string) {
        let listaCampiDeroga: Dati.TListaParametriDeroga = this.state.ListaCampiDeroga;
        if (e.currentTarget.checked) {
            listaCampiDeroga[e.currentTarget.value] = new Dati.CTipoCampoDeroga();
            listaCampiDeroga[e.currentTarget.value].Tipo = tipo;
            listaCampiDeroga[e.currentTarget.value].Verso = verso;
        } else {
            listaCampiDeroga = {};
            for (var I in this.state.ListaCampiDeroga) {
                if (I != e.currentTarget.value) {
                    listaCampiDeroga[I] = this.state.ListaCampiDeroga[I];
                }
            }
        }

        this.setState({ ListaCampiDeroga: listaCampiDeroga });
    }

    private OnRisLimiteDeroga(sender: ChiamaAPI, dati: Dati.CRisAPIDizionario<Dati.CTipoCampoDeroga>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && !dati.Errore /*&& this.state.Dato.Dato.ID_TipoProdotto > 0*/) {
            for (var I in dati.Dati) {
                let indicatore: string = "";
                if (dati.Dati[I].Verso == ">") {
                    indicatore = "MAX";
                }
                else {
                    indicatore = "MIN";
                }

                switch (dati.Dati[I].Tipo) {
                    case "Importo":
                    case "Percentuale":
                        this._LimitiDeroga[I + indicatore] = Number(dati.Dati[I].Valore);
                        break;
                }

                if (dati.Dati[I].Verso == ">") {
                    if (this._Limiti[I + indicatore] == undefined || this._LimitiDeroga[I + indicatore] > this._Limiti[I + indicatore]) {
                        this._Limiti[I + indicatore] = this._LimitiDeroga[I + indicatore];
                    }
                } else {
                    if (this._Limiti[I + indicatore] == undefined || this._LimitiDeroga[I + indicatore] < this._Limiti[I + indicatore]) {
                        this._Limiti[I + indicatore] = this._LimitiDeroga[I + indicatore];
                    }
                }
            }
        }
        return false;
    }

    private OnRisRegola(sender: ChiamaAPI, dati: Dati.CRisAPISemplice<string>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._Regole = dati.Dato;
        }
        return true;
    }

    private OnChangeDataSottoscrizione(e: React.FormEvent<any> | string, valore: Date) {
        let DataScadenza: Date = new Date();
        DataScadenza.setDate(valore.getDate());
        DataScadenza.setMonth(valore.getMonth());
        DataScadenza.setFullYear(valore.getFullYear());
        this.OnChange(e, valore);
        DataScadenza.setFullYear(DataScadenza.getFullYear() + 1);
        this.OnChange("Dato.ScadenzaAffidamento", DataScadenza);
    }

    private OnCaricaLimitiAffidamento(sender: ChiamaAPI, dati: DatiFide.CRisAPIListaLimitiFideAffidamento): React.ReactNode {
        if (dati.Dato != undefined) {
            let etichette: string[] = [];
            let coloriDiSfondo: string[] = [];
            let coloriDiSfondoSuSelezione: string[] = [];

            etichette.push(Trad.Trad("Limite rimasto"));
            etichette.push(Trad.Trad("Limite utilizzato"));
            coloriDiSfondo.push("#4189C7");
            coloriDiSfondo.push("#EAF4F9");
            coloriDiSfondoSuSelezione.push("#4189C7");
            coloriDiSfondoSuSelezione.push("#EAF4F9");


            if (this.state.Dato.Dato.ID_TipoFideAffidamento == Glob.Tipi_FA_Affidamento) {
                return <>
                    <div className="col-lg-3">
                        <GraficoLimite Altezza={100} Larghezza={100} Titolo={Trad.Trad("FA-Provvisorie")} EtichettaConsumato={Trad.Trad("Limite utilizzato")} EtichettaRimanente={Trad.Trad("Limite rimasto")} ValoreConsumato={dati.Dato.LimiteMassimoContraenteUtilizzato_Provvisorie} ValoreRimanente={dati.Dato.LimiteMassimoContraente_Provvisorie - dati.Dato.LimiteMassimoContraenteUtilizzato_Provvisorie} />
                    </div>
                    <div className="col-lg-3">
                        <GraficoLimite Altezza={100} Larghezza={100} Titolo={Trad.Trad("FA-NonProvvisorie")} EtichettaConsumato={Trad.Trad("Limite utilizzato")} EtichettaRimanente={Trad.Trad("Limite rimasto")} ValoreConsumato={dati.Dato.LimiteMassimoContraenteUtilizzato_NonProvvisorie} ValoreRimanente={dati.Dato.LimiteMassimoContraente_NonProvvisorie - dati.Dato.LimiteMassimoContraenteUtilizzato_NonProvvisorie} />
                    </div>
                </>;
            }
            else {
                return <div className="col-lg-6">
                    <GraficoLimite Altezza={100} Larghezza={100} Titolo={Trad.Trad("Utilizzo affidamento")} EtichettaConsumato={Trad.Trad("Limite utilizzato")} EtichettaRimanente={Trad.Trad("Limite rimasto")} ValoreConsumato={dati.Dato.LimiteMassimoContraenteUtilizzato} ValoreRimanente={dati.Dato.LimiteMassimoContraente - dati.Dato.LimiteMassimoContraenteUtilizzato} />
                </div>;
            }
        }
        else {
            return false;
        }
    }

    private ImpostaLimitiPerSOA() {
        if (this.state.LimitiSOA != undefined
            && this.state.Dato.Dato.ID_TipoSOA != undefined
            && this.state.Dato.Dato.ID_TipoSOA != "") {
            let LimiteSOA = 0;
            if (this.state.LimitiSOA.Dati["LimiteSOA-Massimale-" + this.state.Dato.Dato.ID_TipoSOA] != undefined) {
                LimiteSOA = this.state.LimitiSOA.Dati["LimiteSOA-Massimale-" + this.state.Dato.Dato.ID_TipoSOA];
                if (LimiteSOA > 0 && this._Limiti['LimiteMassimoFideiussioneMAX'] > LimiteSOA) {
                    this._Limiti['LimiteMassimoFideiussioneMAX'] = LimiteSOA;
                }
                if (LimiteSOA > 0 && this._Limiti['LimiteMassimoFideiussione_ProvvisorieMAX'] > LimiteSOA) {
                    this._Limiti['LimiteMassimoFideiussione_ProvvisorieMAX'] = LimiteSOA;
                }
            }
            if (this.state.LimitiSOA.Dati["LimiteSOA-Affidamento-" + this.state.Dato.Dato.ID_TipoSOA + "-" + this.state.Dato.Dato.ID_TipoFideAffidamento] != undefined) {
                LimiteSOA = this.state.LimitiSOA.Dati["LimiteSOA-Affidamento-" + this.state.Dato.Dato.ID_TipoSOA + "-" + this.state.Dato.Dato.ID_TipoFideAffidamento];
                if (LimiteSOA > 0 && this._Limiti['LimiteMassimoContraenteMAX'] > LimiteSOA) {
                    this._Limiti['LimiteMassimoContraenteMAX'] = LimiteSOA;
                }
                if (LimiteSOA > 0 && this._Limiti['LimiteMassimoContraente_ProvvisorieMAX'] > LimiteSOA) {
                    this._Limiti['LimiteMassimoContraente_ProvvisorieMAX'] = LimiteSOA;
                }
            }
        }
    }

    private ImpostaLimitiSuVariabiliLocali() {
        switch (this.state.Dato.Dato.ID_TipoFideAffidamento) {
            case Glob.Tipi_FA_NonProvvisorie:
                if (this._LimitiDeroga['LimiteMassimoContraenteMAX'] == undefined) {
                    this._Limiti['LimiteMassimoContraenteMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (this._LimitiDeroga['LimiteMassimoFideiussioneMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussioneMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                break;
            case Glob.Tipi_FA_Provvisorie:
                if (this._LimitiDeroga['LimiteMassimoContraenteMAX'] == undefined) {
                    this._Limiti['LimiteMassimoContraenteMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (this._LimitiDeroga['LimiteMassimoFideiussioneMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussioneMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                break;
            case Glob.Tipi_FA_Affidamento:
                if (this._LimitiDeroga['LimiteMassimoContraente_NonProvvisorieMAX'] == undefined) {
                    this._Limiti['LimiteMassimoContraente_NonProvvisorieMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (this._LimitiDeroga['LimiteMassimoFideiussione_NonProvvisorieMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussione_NonProvvisorieMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorieMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorieMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (this._LimitiDeroga['LimiteMassimoContraente_ProvvisorieMAX'] == undefined) {
                    this._Limiti['LimiteMassimoContraente_ProvvisorieMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (this._LimitiDeroga['LimiteMassimoFideiussione_ProvvisorieMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussione_ProvvisorieMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX'] == undefined) {
                    this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX'] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                break;
        }
    }

    private ImpostaLimitiSuDato() {
        if (this.state.Dato.Dato.LimiteMassimoFideiussione > this._Limiti['LimiteMassimoFideiussioneMAX']) {
            this.state.Dato.Dato.LimiteMassimoFideiussione = this._Limiti['LimiteMassimoFideiussioneMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS > this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX']) {
            this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS = this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoContraente > this._Limiti['LimiteMassimoContraenteMAX']) {
            this.state.Dato.Dato.LimiteMassimoContraente = this._Limiti['LimiteMassimoContraenteMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoFideiussione_Provvisorie > this._Limiti['LimiteMassimoFideiussione_ProvvisorieMAX']) {
            this.state.Dato.Dato.LimiteMassimoFideiussione_Provvisorie = this._Limiti['LimiteMassimoFideiussione_ProvvisorieMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie > this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX']) {
            this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie = this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoContraente_Provvisorie > this._Limiti['LimiteMassimoContraente_ProvvisorieMAX']) {
            this.state.Dato.Dato.LimiteMassimoContraente_Provvisorie = this._Limiti['LimiteMassimoContraente_ProvvisorieMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoFideiussione_NonProvvisorie > this._Limiti['LimiteMassimoFideiussione_NonProvvisorieMAX']) {
            this.state.Dato.Dato.LimiteMassimoFideiussione_NonProvvisorie = this._Limiti['LimiteMassimoFideiussione_NonProvvisorieMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie > this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorieMAX']) {
            this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie = this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorieMAX'];
            this.setState({ Dato: this.state.Dato });
        }
        if (this.state.Dato.Dato.LimiteMassimoContraente_NonProvvisorie > this._Limiti['LimiteMassimoContraente_NonProvvisorieMAX']) {
            this.state.Dato.Dato.LimiteMassimoContraente_NonProvvisorie = this._Limiti['LimiteMassimoContraente_NonProvvisorieMAX'];
            this.setState({ Dato: this.state.Dato });
        }
    }

    private VisualizzaCampiImporti(): React.ReactNode {
        if (this.state.Dato.Dato.ID_TipoFideAffidamento == Glob.Tipi_FA_Affidamento) {
            return <>
                <div className="form-group kt-form login-form__group row">
                    <div className="col-lg-12">
                        <label>{Trad.Trad("FA-Provvisorie")}</label>
                    </div>
                    <div className="col-lg-4">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                            {Trad.Trad("Limite per Contraente / Importo Affidamento")}
                            <input name={"ListaCampiDeroga[LimiteMassimoContraente_Provvisorie]"} value={"LimiteMassimoContraente_Provvisorie"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                            <span></span>
                        </label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero RegoleValidazione={this.RegolaValidazione("LimiteMassimoContraente_Provvisorie", this.state.Dato.Dato)} Id="Dato.LimiteMassimoContraente_Provvisorie" Valore={this.state.Dato.Dato.LimiteMassimoContraente_Provvisorie} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoContraente_Provvisorie" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoContraente_ProvvisorieMAX']} BarraLimiti />
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                            {Trad.Trad("Lim. Fideiussione")}
                            <input name={"ListaCampiDeroga[LimiteMassimoFideiussione_Provvisorie]"} value={"LimiteMassimoFideiussione_Provvisorie"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                            <span></span>
                        </label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id="Dato.LimiteMassimoFideiussione_Provvisorie" Valore={this.state.Dato.Dato.LimiteMassimoFideiussione_Provvisorie} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoFideiussione_Provvisorie" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoFideiussione_ProvvisorieMAX']} BarraLimiti />
                        </div>
                    </div>
                    {Glob.AzioneAbilitata("FideAffidamentoDatiPOS", Glob.Lettura) &&
                        <div className="col-lg-4 ">
                            <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal " title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                                {Trad.Trad("Lim. Fideiussione POS")}
                                <input name={"ListaCampiDeroga[LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie]"} value={"LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                                <span></span>
                            </label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <CampoNumero Id="Dato.LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie" Valore={this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX']} BarraLimiti />
                            </div>
                        </div>
                    }
                </div>
                <div className="form-group kt-form login-form__group row">
                    <div className="col-lg-12">
                        <label>{Trad.Trad("FA-NonProvvisorie")}</label>
                    </div>
                    <div className="col-lg-4">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                            {Trad.Trad("Limite per Contraente / Importo Affidamento")}
                            <input name={"ListaCampiDeroga[LimiteMassimoContraente_NonProvvisorie]"} value={"LimiteMassimoContraente_NonProvvisorie"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                            <span></span>
                        </label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero RegoleValidazione={this.RegolaValidazione("LimiteMassimoContraente_NonProvvisorie", this.state.Dato.Dato)} Id="Dato.LimiteMassimoContraente_NonProvvisorie" Valore={this.state.Dato.Dato.LimiteMassimoContraente_NonProvvisorie} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoContraente_NonProvvisorie" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoContraente_NonProvvisorieMAX']} BarraLimiti />
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                            {Trad.Trad("Lim. Fideiussione")}
                            <input name={"ListaCampiDeroga[LimiteMassimoFideiussione_NonProvvisorie]"} value={"LimiteMassimoFideiussione_NonProvvisorie"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                            <span></span>
                        </label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id="Dato.LimiteMassimoFideiussione_NonProvvisorie" Valore={this.state.Dato.Dato.LimiteMassimoFideiussione_NonProvvisorie} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoFideiussione_NonProvvisorie" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoFideiussione_NonProvvisorieMAX']} BarraLimiti />
                        </div>
                    </div>
                    {Glob.AzioneAbilitata("FideAffidamentoDatiPOS", Glob.Lettura) &&
                        <div className="col-lg-4 ">
                            <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal " title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                                {Trad.Trad("Lim. Fideiussione POS")}
                                <input name={"ListaCampiDeroga[LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie]"} value={"LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                                <span></span>
                            </label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <CampoNumero Id="Dato.LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie" Valore={this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX_NonProvvisorie']} BarraLimiti />
                            </div>
                        </div>
                    }
                </div>
            </>;
        }
        else {
            return <div className="form-group kt-form login-form__group row">
                <div className="col-lg-4">
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                        {Trad.Trad("Limite per Contraente / Importo Affidamento")}
                        <input name={"ListaCampiDeroga[LimiteMassimoContraente]"} value={"LimiteMassimoContraente"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                        <span></span>
                    </label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero RegoleValidazione={this.RegolaValidazione("LimiteMassimoContraente", this.state.Dato.Dato)} Id="Dato.LimiteMassimoContraente" Valore={this.state.Dato.Dato.LimiteMassimoContraente} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoContraente" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoContraenteMAX']} BarraLimiti />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                        {Trad.Trad("Lim. Fideiussione")}
                        <input name={"ListaCampiDeroga[LimiteMassimoFideiussione]"} value={"LimiteMassimoFideiussione"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                        <span></span>
                    </label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero Id="Dato.LimiteMassimoFideiussione" Valore={this.state.Dato.Dato.LimiteMassimoFideiussione} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoFideiussione" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoFideiussioneMAX']} BarraLimiti />
                    </div>
                </div>
                {Glob.AzioneAbilitata("FideAffidamentoDatiPOS", Glob.Lettura) &&
                    <div className="col-lg-4 ">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal " title={Trad.Trad("Limite per Contraente / Importo Affidamento")}>
                            {Trad.Trad("Lim. Fideiussione POS")}
                            <input name={"ListaCampiDeroga[LimiteMassimoFideiussioneAutonomiaPOS]"} value={"LimiteMassimoFideiussioneAutonomiaPOS"} type="checkbox" onChange={(e) => this.OnChangeDeroga(e, "Importo", ">")} />
                            <span></span>
                        </label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <CampoNumero Id="Dato.LimiteMassimoFideiussioneAutonomiaPOS" Valore={this.state.Dato.Dato.LimiteMassimoFideiussioneAutonomiaPOS} OnChange={(e) => { this.OnChange(e) }} Name="Dato.LimiteMassimoFideiussioneAutonomiaPOS" CSS="form-control kt-input" Icona="la la-money" Minimo={0} Massimo={this._Limiti['LimiteMassimoFideiussioneAutonomiaPOSMAX']} BarraLimiti />
                        </div>
                    </div>
                }
            </div>;
        }
    }

    public render() {
        if (!this.ControlloAutorizzazione("FideAffidamentoController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));
        var caricaDocumenti = <div></div>;
        if (this.ID_FideAffidamento > 0) {
            caricaDocumenti = <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                <a href={"/file/" + this.ID_FideAffidamento} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Documenti")}>
                    <i className="fa fa-archive"></i>
                    {Trad.Trad("Documenti")}
                </a>
            </div>;
        }

        this.ImpostaLimitiSuVariabiliLocali();
        this.ImpostaLimitiPerSOA();
        this.ImpostaLimitiSuDato();

        let URLGruppo: string = "/api/fideaffidamento/GetLimitiCapogruppo?ID_FideAffidamento=" + this.ID_FideAffidamento + "&ID_Anag=" + (this.props.match.params as any).ID_Anag;

        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-pencil-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Affidamento")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            {caricaDocumenti}
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                <a href={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/" + this.ID_FideAffidamento + "/coobbligato"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Coobbligati")}>
                                    <i className="fa fa-users"></i>
                                    {Trad.Trad("Coobbligati")}
                                </a>
                            </div>
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <NavLink to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                    {Trad.Trad("Nuovo")}
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-2">
                                {(this.state.Dato.Dato.ID_TipoFideAffidamento != Glob.Tipi_FA_Affidamento) &&
                                    <div className="kt-radio-list">
                                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                            <input name="Dato.ID_TipoFideAffidamento" value={Glob.Tipi_FA_Provvisorie} type="radio" checked={this.state.Dato.Dato.ID_TipoFideAffidamento == Glob.Tipi_FA_Provvisorie} onChange={this.OnChangeTipoAffidamento} />{Trad.Trad("Provvisorie")}<span></span>
                                        </label>
                                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                            <input name="Dato.ID_TipoFideAffidamento" value={Glob.Tipi_FA_NonProvvisorie} type="radio" checked={this.state.Dato.Dato.ID_TipoFideAffidamento == Glob.Tipi_FA_NonProvvisorie} onChange={this.OnChangeTipoAffidamento} />{Trad.Trad("Non provvisorie")}<span></span>
                                        </label>
                                    </div>
                                }
                            </div>
                            <div className="col-lg-4">
                                <ChiamaAPI Aggiornare={this.state.Dato.Dato.ID_FideAffidamento} URL={URLGruppo} OnRis={(s, d) => this.OnCaricaLimitiCapogruppo(s, d)} OnErrore={this.OnErrore} />
                            </div>
                            <ChiamaAPI Aggiornare={this.state.Dato.Dato.ID_FideAffidamento} URL={"/api/fideaffidamento/GetLimiti?ID_FideAffidamento=" + this.state.Dato.Dato.ID_FideAffidamento} OnRis={(s, d) => this.OnCaricaLimitiAffidamento(s, d)} OnErrore={this.OnErrore} />
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-2">
                                <label>ID</label>
                                <input className="form-control kt-input" placeholder="ID" name="Dato.ID_FideAffidamento" type="text" value={this.state.Dato.Dato.ID_FideAffidamento} disabled />
                            </div>
                            <div className="col-lg-5">
                                <label>{Trad.Trad("Affidatario")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="Dato.ID_AnagDa" ID_ChiaveString={this.state.Dato.Dato.ID_AnagDa.toString() || ""} OnAggiorna={this.OnChange} Disabilitato={this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto || this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Revisione} TradValori LinkSelezione="/anagrafica/" />
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <label>{Trad.Trad("Affidato")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="Dato.ID_AnagA" ID_ChiaveString={this.state.Dato.Dato.ID_AnagA.toString() || ""} OnAggiorna={this.OnChange} Disabilitato TradValori LinkSelezione="/anagrafica/" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row" >
                            <div className="col-lg-3">
                                <label>{Trad.Trad("Stato")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <Tipo Campo="Dato.ID_TipoFideAffidamentoEsito" ID_ChiaveString={this.state.Dato.Dato.ID_TipoFideAffidamentoEsito || Glob.Tipi_FAE_CreazioneAffidamento} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi["FideAffidamentoEsito"]} TradValori Disabilitato={this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto} />
                                </div>
                            </div>
                            <div className={"col-lg-3" + (this.state.Dato.Dato.ID_TipoFideAffidamento == Glob.Tipi_FA_NonProvvisorie ? "hidden" : "")}>
                                <label>SOA</label>
                                <Tipo Campo="Dato.ID_TipoSOA" ID_ChiaveString={this.state.Dato.Dato.ID_TipoSOA} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi["TipiSOA"]} TradValori={false} Disabilitato={this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto || this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Revisione} />
                            </div>
                            {Glob.AzioneAbilitata("FideAffidamentoDatiPOS", Glob.Lettura) &&
                                <div className="col-lg-3">
                                    <label className="">{Trad.Trad("Data sottoscrizione")}</label>
                                    <div className="kt-input-icon kt-input-icon--right">
                                        <div className="form-control">
                                            <CampoData ValoreInArrivo={this.ID_FideAffidamento > 0}
                                                Name="Dato.Data"
                                                Id="Dato.Data"
                                                Valore={this.state.Dato.Dato.Data}
                                                OnChange={this.OnChangeDataSottoscrizione}
                                                Disabilitato={this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto || this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Revisione} />
                                        </div>
                                    </div>
                                </div>
                            }
                            {Glob.AzioneAbilitata("FideAffidamentoDatiPOS", Glob.Lettura) &&
                                <div className="col-lg-3">
                                    <label className="">{Trad.Trad("Data scadenza")}</label>
                                    <div className="kt-input-icon kt-input-icon--right">
                                        <div className="form-control">
                                            <CampoData ValoreInArrivo={this.ID_FideAffidamento > 0}
                                                Name="Dato.ScadenzaAffidamento"
                                                Id="Dato.ScadenzaAffidamento"
                                                Valore={this.state.Dato.Dato.ScadenzaAffidamento}
                                                OnChange={this.OnChange}
                                                Disabilitato={this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto || this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Revisione} />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        {this.VisualizzaCampiImporti()}
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12">
                                <label>{Trad.Trad("ListaBinder")}</label>
                                <Tipo SceltaMultipla URL={"/api/FideAffidamento/ListaBinderDisponibili?id_AnagDa=" + (this.state.Dato.Dato.ID_AnagDa.toString() || "")}
                                    Campo={"Dato.ListaBinderJSON"}
                                    ID_ChiaveString={this.state.Dato.Dato.ListaBinderJSON} OnAggiorna={this.OnChange}
                                    TradValori={false} />
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12">
                                <label className="">
                                    {Trad.Trad("Commenti")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <textarea className="form-control" id="kt_autosize_1" rows={3} name="Dato.Dato.Note" value={this.state.Dato.Dato.Note || ""} onChange={this.OnChange}></textarea>
                                </div>
                            </div>
                        </div>
                        <FideAffidamentoApprovazione
                            Id="Dato.FideAffidamentoApprovazione"
                            Dati={this.state.Dato.Dato.ListaFideAffidamentoApprovazioneJSON}
                            OnChange={(e, v) => this.OnChange(e, v)}
                            TipiFideAffidamentoApprovazione={this.state.Dato.Tipi["FideAffidamentoApprovazione"]}
                            Name="Dato.ListaFideAffidamentoApprovazioneJSON" />
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <BottoneAPI Default Testo={Trad.Trad("Salva")} URL="/api/fideaffidamento/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura && this._ID_TipoFideAffidamentoEsito != Glob.Tipi_FAE_Sottoscritto} />
                                    &nbsp;<BottoneAPI ClasseAttivo="btn btn-warning" Testo={Trad.Trad("Revisione affidamento")} URL="/api/fideaffidamento/" Metodo="POST" OnInvio={(s) => this.OnInvioRevisione(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura && this._ID_TipoFideAffidamentoEsito == Glob.Tipi_FAE_Sottoscritto} />
                                    <ChiamaAPI Aggiornare={1} URL={"/api/fideaffidamento/seleziona?ID_FideAffidamento=" + this.ID_FideAffidamento + "&DataRiferimento=" + this._DataRiferimento} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                                    <ChiamaAPI Aggiornare={1} URL="/api/fideaffidamento/LimitiSOA" OnRis={(s, d, dn) => this.OnRisLimitiSOA(s, d, dn)} OnErrore={this.OnErrore} />
                                    &nbsp;<Deroga Id="Deroga" Name="Deroga" OnChange={() => { }} Tipo={Glob.Tipi_DT_Fideiussione} Valore={this.state.ListaCampiDeroga} ID={this.ID_FideAffidamento} />
                                    <ChiamaAPI Aggiornare={this.state.Dato.Dato.ID_TipoProdotto + this._Incremento} URL={"/api/deroga/GetLimitiDeroga?ID_Deroga=" + (this.props.match.params as any).ID_FideAffidamento + "&ID_TipoDerogaStato=" + Glob.Tipi_DR_Approvata} OnRis={(s, d, dn) => this.OnRisLimiteDeroga(s, d, dn)} OnErrore={this.OnErrore} />
                                    <ChiamaAPI Aggiornare={this.state.Dato.Dato.ID_TipoProdotto + this._Incremento} URL={"/api/regole/Get?id_Regola=RegolaFideAffidamento"} OnRis={(s, d, dn) => this.OnRisRegola(s, d, dn)} OnErrore={this.OnErrore} />
                                    &nbsp;<CambioStatoBottoni
                                        Stati={this.state.Dato.Tipi["FideAffidamentoEsito"]}
                                        StatoCorrente={this.state.Dato.Dato.ID_TipoFideAffidamentoEsito}
                                        OnInvio={(sender, nuovoStato) => this.OnInvioSalvaCambioStato(nuovoStato)}
                                        URL="/api/fideaffidamento/"
                                        Metodo="POST"
                                        OnErrore={this.OnErroreBottoneAPI}
                                        OnClick={(s, d) => { this.OnClickSalva(s, d); this.props.history.goBack(); } }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/FideAffidamento.tsx